import { render, staticRenderFns } from "./MonthlyTotalCard.vue?vue&type=template&id=5f74e6a3&scoped=true&"
import script from "./MonthlyTotalCard.vue?vue&type=script&lang=js&"
export * from "./MonthlyTotalCard.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyTotalCard.vue?vue&type=style&index=0&id=5f74e6a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f74e6a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
